import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateReportPipe } from './translate-report/translate-report.pipe';
import { ReportCenterIconPipe } from './report-center-icon/report-center-icon.pipe';

const allModules = [
    TranslateReportPipe,
    ReportCenterIconPipe,
];

@NgModule({
    declarations: [...allModules],
    imports: [
        CommonModule,
    ],
    providers: [TranslateReportPipe],
    exports: [...allModules],
})
export class ReportCenterPipesModule {}
